// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._z-0 {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n._z-1 {\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n._z-2 {\n  font-weight: 500;\n  text-decoration: underline;\n  white-space: nowrap;\n  cursor: pointer;\n}\n", ""]);
// Exports
export var checkIcon = "_z-0";
export var text = "_z-1";
export var learnMore = "_z-2";
export default ___CSS_LOADER_EXPORT___;
